import { ChangeDetectionStrategy, Component, Input, OnInit, WritableSignal, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionTitlePipe } from '../question-title.pipe';
import { DiagramComponent } from '../diagram/diagram.component';
import { OptionData, QuestionData } from 'src/app/models/QuestionnaireDataByQuestions.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ContactCircleComponent } from '../contact-circle/contact-circle.component';
import { ContactTooltipComponent } from 'src/app/shared/components/contact-tooltip/contact-tooltip.component';
import { DataSummaryStore } from 'src/app/features/questionnaires/store/data-summary-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { RangeDiagramComponent } from '../range-diagram/range-diagram.component';
@Component({
    selector: 'que-answers-in-range',
    imports: [CommonModule, QuestionTitlePipe, RangeDiagramComponent, TranslateDirective, TranslatePipe, ContactCircleComponent, ContactTooltipComponent],
    templateUrl: './answers-in-range.component.html',
    styleUrls: ['./answers-in-range.component.scss']
})
export class AnswersInRangeComponent implements OnInit {
  @Input()
  questionData?: QuestionData;
  #storeData = inject(DataSummaryStore);
  filterRecipients$ = toSignal(this.#storeData.recipientsToFilterId$.pipe(tap(x => this.filterTheOptionsById(x))));
  showComparison$ = toSignal(this.#storeData.showComparison$);
  options?: OptionData[];
  // options$:WritableSignal<OptionData[] | undefined> = signal(undefined);

  ngOnInit(): void {
    this.filterTheOptions();
  }
  ngOnChanges() {
    this.filterTheOptions();

    console.log('[answers] qId=', this.questionData?.question?.id,
      'recipients=', this.questionData?.recipients?.length,
      'recipientIds=', (this.questionData?.recipients ?? []).map((r: any) => r?.recipient?.id));
  }
  filterTheOptions() {
    if (this.filterRecipients$() != undefined) {
      this.options = this.questionData?.options?.map(op => {
        var isCurrent = op.recipients.findIndex(r => r.user.id == (this.filterRecipients$())) != -1
        var isPervious = op.recipientsSource.findIndex(r => r.user.id == (this.filterRecipients$())) != -1
        return {
          ...op, percent: isCurrent ? 100 : 0,
          percentSource: isPervious ? 100 : 0,
          wasChange: isCurrent != isPervious
        };
      });
    }
    else {
      this.options = this.questionData?.options;
    }
  }
  filterTheOptionsById(id?: number) {
    if (id != undefined) {
      this.options = this.questionData?.options?.map(op => {
        var isCurrent = op.recipients.findIndex(r => r.user.id == id) != -1
        var isPervious = op.recipientsSource.findIndex(r => r.user.id == id) != -1
        return {
          ...op, percent: isCurrent ? 100 : 0,
          percentSource: isPervious ? 100 : 0,
          wasChange: isCurrent != isPervious
        };
      });
    }
    else {
      this.options = this.questionData?.options;
    }
  }

}
